"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
import { Link } from "@/components/common/Link";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Card, CardContent } from "@/components/ui/card";
function PostsGridConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div data-section-id="164788" className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 md:gap-8">
        {[...Array(3)].map((_, i) => <Card key={i} data-index={i} className="bg-card border-none overflow-hidden rounded-[6px] p-0 gap-0 animate-pulse">
            <AspectRatio ratio={16 / 9} className="bg-muted" />
            <CardContent className="p-6">
              <div className="mb-4 h-6 w-3/4 rounded bg-muted" />
              <div className="mb-2 h-4 w-full rounded bg-muted" />
              <div className="mb-6 h-4 w-2/3 rounded bg-muted" />
              <div className="h-4 w-24 rounded bg-muted" />
            </CardContent>
          </Card>)}
      </div>;
  }
  if (error) {
    return <div className="py-12 text-center text-destructive">
        <p>Gagal memuat berita terkait. Silakan coba lagi nanti.</p>
      </div>;
  }
  if (!posts || posts.length === 0) {
    return <div className="py-12 text-center text-muted-foreground">
        <p>Tidak ada berita terkait yang tersedia saat ini.</p>
      </div>;
  }
  return <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3 md:gap-8">
      {posts.map((post, i) => <Card key={post.id} data-index={i} className="group flex flex-col overflow-hidden rounded-[6px] border-transparent bg-card p-0 gap-0 transition-all duration-400 hover:-translate-y-1 hover:border-[#E5E5E5] hover:border hover:shadow-[0px_4px_10px_0px_rgba(0,0,0,0.05)]">
          <div className="relative block overflow-hidden">
            <div className="absolute top-3 left-3 z-10 bg-primary px-2 py-0.5 text-[10px] font-bold text-white rounded-[2px] uppercase tracking-wider">
              Klarifikasi
            </div>
            <Link to={post.link || "#"} className="block overflow-hidden">
              <AspectRatio ratio={16 / 9}>
                <img src={post.featuredImage || "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1580001/img/generic_blog_placeholder.png"} alt={post.title} className="h-full w-full object-cover transition-all duration-500 group-hover:scale-105" />
              </AspectRatio>
            </Link>
          </div>
          <CardContent className="flex flex-grow flex-col p-5 md:p-6">
            <Link to={post.link || "#"} className="mb-3 block">
              <h3 style={{
            fontFamily: "Inter, sans-serif"
          }} className="line-clamp-2 text-xl font-bold leading-tight text-card-foreground md:text-2xl">
                {post.title}
              </h3>
            </Link>
            <p className="mb-6 flex-grow font-sans text-sm text-muted-foreground line-clamp-3 md:text-base">
              {post.excerpt?.replace(/(<([^>]+)>)/gi, "") || "Baca selengkapnya mengenai topik ini dalam artikel terbaru kami."}
            </p>
            <div className="mt-auto">
              <Link to={post.link || "#"} className="group/link inline-flex items-center text-sm font-medium text-primary transition-colors hover:text-primary/80">
                Baca Selengkapnya
                <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover/link:translate-x-1" />
              </Link>
            </div>
          </CardContent>
        </Card>)}
    </div>;
}
export default function RecentPosts() {
  const wp_query_params = {
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section id="related-articles" className="bg-background py-16 border-t border-[#F2F2F2] text-foreground md:py-24">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12">
          <h2 style={{
          fontFamily: "Inter, sans-serif"
        }} className="text-[32px] font-bold tracking-tight text-foreground">
            Berita Terkait
          </h2>
        </div>
        <PostsProvider wp_query={{
        per_page: 3,
        order: "desc",
        orderby: "date"
      }}>
          <PostsGridConsumer />
        </PostsProvider>
      </div>
    </section>;
}